export default __webpack_public_path__ + "static/media/background-5.9a5b1fb8.png";